<ng-container *ngIf="baseState$ | async as state">
  <mb-link *ngIf="state.data && state.isVisible"
           [dataCy]="'call-to-action-button-' + number"
           [linkData]="state.data.link"
           [styleClass]="['call-to-action','btn', 'btn-lg', state.data.highlight ? 'btn-primary' : 'btn-secondary']"
  ></mb-link>
</ng-container>
